import {useEffect, useState} from 'react';

const useSetInitialProvince = (province: Array<IProvince> | undefined) => {
  const [state, setState] = useState<IOption | undefined>();
  const [city, setCity] = useState<IOption | undefined>();
  const user: string | null = window.localStorage.getItem('user');
  useEffect(() => {
    if (user) {
      const jsonUser: IUser = JSON.parse(user);
      const provinceState = province?.find(
        item => jsonUser.profile.state === item.id,
      );
      if (provinceState) {
        const provinceCity = provinceState.cities.find(
          item => jsonUser.profile.city === item.id,
        );
        if (provinceCity) {
          setCity({label: provinceCity?.name, value: provinceCity?.id});
        }
        setState({label: provinceState.name, value: provinceState.id});
      }
    }
  }, [user, province]);
  return {state, city};
};

export default useSetInitialProvince;
